import { render, staticRenderFns } from "./BlockFiltersModal.vue?vue&type=template&id=1babc2e2&scoped=true&"
import script from "./BlockFiltersModal.vue?vue&type=script&lang=js&"
export * from "./BlockFiltersModal.vue?vue&type=script&lang=js&"
import style0 from "./BlockFiltersModal.vue?vue&type=style&index=0&id=1babc2e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1babc2e2",
  null
  
)

export default component.exports